import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { Card } from '../components/ui/Card';
import { ArrowDownIcon, RefreshCwIcon, AlertCircleIcon } from 'lucide-react';
export function CryptoSwap() {
  return <div data-id="element-242">
      <PageHeader title="Crypto Swap" description="Swap between different cryptocurrencies at the best rates" data-id="element-243" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-244">
        <div className="lg:col-span-2" data-id="element-245">
          <Card title="Swap Crypto" data-id="element-246">
            <div className="space-y-6" data-id="element-247">
              {/* From Currency */}
              <div data-id="element-248">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-249">
                  From
                </label>
                <div className="relative rounded-md shadow-sm" data-id="element-250">
                  <input type="text" className="focus:ring-blue-500 focus:border-blue-500 block w-full pr-20 sm:text-sm border-gray-300 rounded-md" placeholder="0.00" data-id="element-251" />
                  <div className="absolute inset-y-0 right-0 flex items-center" data-id="element-252">
                    <label htmlFor="fromCurrency" className="sr-only" data-id="element-253">
                      Currency
                    </label>
                    <select id="fromCurrency" name="fromCurrency" className="focus:ring-blue-500 focus:border-blue-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-500 sm:text-sm rounded-md" data-id="element-254">
                      <option data-id="element-255">BTC</option>
                      <option data-id="element-256">ETH</option>
                      <option data-id="element-257">SOL</option>
                      <option data-id="element-258">XRP</option>
                    </select>
                  </div>
                </div>
                <p className="mt-1 text-sm text-gray-500" data-id="element-259">
                  Available: 0.0542 BTC
                </p>
              </div>
              {/* Swap Icon */}
              <div className="flex justify-center" data-id="element-260">
                <div className="p-2 bg-gray-100 rounded-full" data-id="element-261">
                  <ArrowDownIcon className="h-6 w-6 text-gray-500" data-id="element-262" />
                </div>
              </div>
              {/* To Currency */}
              <div data-id="element-263">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-264">
                  To
                </label>
                <div className="relative rounded-md shadow-sm" data-id="element-265">
                  <input type="text" className="focus:ring-blue-500 focus:border-blue-500 block w-full pr-20 sm:text-sm border-gray-300 rounded-md" placeholder="0.00" readOnly value="1.82" data-id="element-266" />
                  <div className="absolute inset-y-0 right-0 flex items-center" data-id="element-267">
                    <label htmlFor="toCurrency" className="sr-only" data-id="element-268">
                      Currency
                    </label>
                    <select id="toCurrency" name="toCurrency" className="focus:ring-blue-500 focus:border-blue-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-500 sm:text-sm rounded-md" data-id="element-269">
                      <option data-id="element-270">ETH</option>
                      <option data-id="element-271">BTC</option>
                      <option data-id="element-272">SOL</option>
                      <option data-id="element-273">XRP</option>
                    </select>
                  </div>
                </div>
              </div>
              {/* Swap Details */}
              <div className="bg-gray-50 p-4 rounded-md" data-id="element-274">
                <div className="flex justify-between mb-2" data-id="element-275">
                  <span className="text-sm text-gray-500" data-id="element-276">Exchange Rate</span>
                  <span className="text-sm font-medium" data-id="element-277">1 BTC = 18.2 ETH</span>
                </div>
                <div className="flex justify-between mb-2" data-id="element-278">
                  <span className="text-sm text-gray-500" data-id="element-279">Fee</span>
                  <span className="text-sm font-medium" data-id="element-280">0.0001 BTC</span>
                </div>
                <div className="flex justify-between" data-id="element-281">
                  <span className="text-sm text-gray-500" data-id="element-282">Estimated Time</span>
                  <span className="text-sm font-medium" data-id="element-283">1-5 minutes</span>
                </div>
              </div>
              {/* Swap Button */}
              <button type="button" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-284">
                <RefreshCwIcon className="mr-2 h-5 w-5" data-id="element-285" />
                Swap Now
              </button>
            </div>
          </Card>
        </div>
        <div data-id="element-286">
          <Card title="Market Rates" data-id="element-287">
            <div className="space-y-4" data-id="element-288">
              {[{
              pair: 'BTC/ETH',
              rate: '18.2',
              change: '+1.2%'
            }, {
              pair: 'BTC/SOL',
              rate: '645.3',
              change: '-0.8%'
            }, {
              pair: 'ETH/SOL',
              rate: '35.4',
              change: '-2.1%'
            }, {
              pair: 'BTC/XRP',
              rate: '65,432',
              change: '+3.5%'
            }].map((rate, i) => <div key={i} className="flex justify-between items-center border-b pb-2 last:border-b-0 last:pb-0" data-id="element-289">
                  <div data-id="element-290">
                    <p className="font-medium" data-id="element-291">{rate.pair}</p>
                  </div>
                  <div className="text-right" data-id="element-292">
                    <p className="font-medium" data-id="element-293">{rate.rate}</p>
                    <p className={`text-sm ${rate.change.startsWith('+') ? 'text-green-600' : 'text-red-600'}`} data-id="element-294">
                      {rate.change}
                    </p>
                  </div>
                </div>)}
            </div>
          </Card>
          <Card title="Recent Swaps" className="mt-6" data-id="element-295">
            <div className="space-y-4" data-id="element-296">
              {[{
              from: '0.01 BTC',
              to: '0.182 ETH',
              time: '5 mins ago'
            }, {
              from: '0.5 ETH',
              to: '17.7 SOL',
              time: '20 mins ago'
            }, {
              from: '10 SOL',
              to: '0.28 ETH',
              time: '1 hour ago'
            }].map((swap, i) => <div key={i} className="flex justify-between items-center border-b pb-2 last:border-b-0 last:pb-0" data-id="element-297">
                  <div className="flex items-center" data-id="element-298">
                    <RefreshCwIcon className="h-4 w-4 text-gray-400 mr-2" data-id="element-299" />
                    <div data-id="element-300">
                      <p className="text-sm font-medium" data-id="element-301">
                        {swap.from} → {swap.to}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-302">{swap.time}</p>
                    </div>
                  </div>
                </div>)}
            </div>
          </Card>
          <div className="mt-6 bg-yellow-50 border border-yellow-200 rounded-md p-4" data-id="element-303">
            <div className="flex" data-id="element-304">
              <div className="flex-shrink-0" data-id="element-305">
                <AlertCircleIcon className="h-5 w-5 text-yellow-400" data-id="element-306" />
              </div>
              <div className="ml-3" data-id="element-307">
                <h3 className="text-sm font-medium text-yellow-800" data-id="element-308">
                  Important Note
                </h3>
                <div className="mt-2 text-sm text-yellow-700" data-id="element-309">
                  <p data-id="element-310">
                    Crypto swaps are subject to market fluctuations. The final
                    amount may vary slightly from the estimated amount.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}